<template>
  <div id="ranking-regional-filters" class="ranking-filters">
    <div class="filters-left">
      <div class="filter-item">
        <label>Quadrimestre</label>
        <select
          :value="quadrimestre"
          @change="$emit('change-quadrimestre', $event.target.value)"
        >
          <option
            v-for="item in quadrimestres"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </option>
        </select>
      </div>

      <div class="filter-item">
        <label>Região</label>
        <select
          :value="regiaoIbge"
          :disabled="!quadrimestre"
          @change="$emit('change-regiao-ibge', $event.target.value)"
        >
          <option value=""></option>
          <option
            v-for="item in regioesIbge"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </option>
        </select>
      </div>

      <div class="filter-item">
        <label>UF</label>
        <select
          :value="estado"
          :disabled="!regiaoIbge"
          @change="$emit('change-estado', $event.target.value)"
        >
          <option value=""></option>
          <option v-for="item in estados" :key="item.uf" :value="item.uf">
            {{ item.uf }}
          </option>
        </select>
      </div>

      <div class="filter-item">
        <label>Macro Região</label>
        <select
          :value="macroRegiaoSaude"
          :disabled="!estado"
          @change="$emit('change-macro-regiao-saude', $event.target.value)"
        >
          <option value=""></option>
          <option v-for="item in macroRegioesSaude" :key="item" :value="item">
            {{ item }}
          </option>
        </select>
      </div>

      <div class="filter-item">
        <label>Regional</label>
        <select
          :value="regiaoSaude"
          :disabled="!macroRegiaoSaude"
          @change="$emit('change-regiao-saude', $event.target.value)"
        >
          <option value=""></option>
          <option v-for="item in regioesSaude" :key="item" :value="item">
            {{ item }}
          </option>
        </select>
      </div>

      <div class="filter-actions">
        <button class="btn-clear" @click="$emit('limpar')">Limpar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RankingRegionalFilters',
  props: {
    quadrimestre: { type: String, default: '' },
    regiaoIbge: { type: String, default: '' },
    estado: { type: String, default: '' },
    macroRegiaoSaude: { type: String, default: '' },
    regiaoSaude: { type: String, default: '' },
    quadrimestres: { type: Array, default: () => [] },
    regioesIbge: { type: Array, default: () => [] },
    estados: { type: Array, default: () => [] },
    macroRegioesSaude: { type: Array, default: () => [] },
    regioesSaude: { type: Array, default: () => [] },
  },
}
</script>

<style scoped lang="scss">
#ranking-regional-filters {
  margin-bottom: 20px;

  .filters-left {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 16px;
    align-items: end;
    width: 100%;
  }

  .filter-item {
    display: flex;
    flex-direction: column;
    min-width: 0;

    label {
      font-size: 13px;
      font-weight: 700;
      color: #374151;
      margin-bottom: 6px;
    }

    select {
      width: 100%;
      height: 42px;
      border: 1px solid #e5e7eb;
      border-radius: 10px;
      padding: 0 12px;
      outline: none;
      background: #ffffff;
      transition: border-color 0.2s;

      &:focus {
        border-color: #0d98bb;
      }

      &:disabled {
        background: #f5f5f5;
        cursor: not-allowed;
      }
    }
  }

  .filter-actions {
    display: flex;
    align-items: flex-end;

    button {
      width: 100%;
      height: 42px;
      border: none;
      border-radius: 10px;
      font-weight: 700;
      cursor: pointer;
    }

    .btn-clear {
      background: #e5e7eb;
      color: #374151;
      transition: background 0.2s;

      &:hover {
        background: #d1d5db;
      }
    }
  }

  @media (max-width: 1200px) {
    .filters-left {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }

  @media (max-width: 992px) {
    .filters-left {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media (max-width: 768px) {
    .filters-left {
      grid-template-columns: 1fr;
    }
  }
}
</style>
